

































































































































import ContentsTemplate from '@/views/templates/ContentsTemplate.vue'
export default 
  name: 'PrivacyPolicy'

  components: {
    ContentsTemplate
  }

  created: () ->
    @.$emit('header_title', 'プライバシーポリシー')
    window.scrollTo(0, 0)

